module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-bar-right-c6f56fcd.svg";